{
  "Items": [
    {
      "Id": 16,
      "Name": "Wild Horseradish",
      "SellPrice": 50,
      "Category": "Forage"
    },
    {
      "Id": 18,
      "Name": "Daffodil",
      "SellPrice": 30,
      "Category": "Forage"
    },
    {
      "Id": 20,
      "Name": "Leek",
      "SellPrice": 60,
      "Category": "Forage"
    },
    {
      "Id": 22,
      "Name": "Dandelion",
      "SellPrice": 40,
      "Category": "Forage"
    },
    {
      "Id": 24,
      "Name": "Parsnip",
      "SellPrice": 35,
      "Category": "Vegetable"
    },
    {
      "Id": 90,
      "Name": "Cactus Fruit",
      "SellPrice": 75,
      "Category": "Fruit"
    },
    {
      "Id": 178,
      "Name": "Hay",
      "SellPrice": 0,
      "Category": "Other"
    },
    {
      "Id": 188,
      "Name": "Green Bean",
      "SellPrice": 40,
      "Category": "Vegetable"
    },
    {
      "Id": 190,
      "Name": "Cauliflower",
      "SellPrice": 175,
      "Category": "Vegetable"
    },
    {
      "Id": 192,
      "Name": "Potato",
      "SellPrice": 80,
      "Category": "Vegetable"
    },
    {
      "Id": 245,
      "Name": "Sugar",
      "SellPrice": 50,
      "Category": "Other"
    },
    {
      "Id": 246,
      "Name": "Wheat Flour",
      "SellPrice": 50,
      "Category": "Other"
    },
    {
      "Id": 247,
      "Name": "Oil",
      "SellPrice": 100,
      "Category": "Other"
    },
    {
      "Id": 248,
      "Name": "Garlic",
      "SellPrice": 60,
      "Category": "Vegetable"
    },
    {
      "Id": 250,
      "Name": "Kale",
      "SellPrice": 110,
      "Category": "Vegetable"
    },
    {
      "Id": 252,
      "Name": "Rhubarb",
      "SellPrice": 220,
      "Category": "Fruit"
    },
    {
      "Id": 254,
      "Name": "Melon",
      "SellPrice": 250,
      "Category": "Fruit"
    },
    {
      "Id": 256,
      "Name": "Tomato",
      "SellPrice": 60,
      "Category": "Vegetable"
    },
    {
      "Id": 258,
      "Name": "Blueberry",
      "SellPrice": 50,
      "Category": "Fruit"
    },
    {
      "Id": 260,
      "Name": "Hot Pepper",
      "SellPrice": 40,
      "Category": "Fruit"
    },
    {
      "Id": 262,
      "Name": "Wheat",
      "SellPrice": 25,
      "Category": "Vegetable"
    },
    {
      "Id": 264,
      "Name": "Radish",
      "SellPrice": 90,
      "Category": "Vegetable"
    },
    {
      "Id": 266,
      "Name": "Red Cabbage",
      "SellPrice": 260,
      "Category": "Vegetable"
    },
    {
      "Id": 268,
      "Name": "Starfruit",
      "SellPrice": 750,
      "Category": "Fruit"
    },
    {
      "Id": 270,
      "Name": "Corn",
      "SellPrice": 50,
      "Category": "Vegetable"
    },
    {
      "Id": 271,
      "Name": "Unmilled Rice",
      "SellPrice": 30,
      "Category": "Vegetable"
    },
    {
      "Id": 272,
      "Name": "Eggplant",
      "SellPrice": 60,
      "Category": "Vegetable"
    },
    {
      "Id": 273,
      "Name": "Rice Shoot",
      "SellPrice": 20,
      "Category": "Seeds"
    },
    {
      "Id": 274,
      "Name": "Artichoke",
      "SellPrice": 160,
      "Category": "Vegetable"
    },
    {
      "Id": 276,
      "Name": "Pumpkin",
      "SellPrice": 320,
      "Category": "Vegetable"
    },
    {
      "Id": 278,
      "Name": "Bok Choy",
      "SellPrice": 80,
      "Category": "Vegetable"
    },
    {
      "Id": 280,
      "Name": "Yam",
      "SellPrice": 160,
      "Category": "Vegetable"
    },
    {
      "Id": 282,
      "Name": "Cranberries",
      "SellPrice": 75,
      "Category": "Fruit"
    },
    {
      "Id": 284,
      "Name": "Beet",
      "SellPrice": 100,
      "Category": "Vegetable"
    },
    {
      "Id": 299,
      "Name": "Amaranth Seeds",
      "SellPrice": 35,
      "Category": "Seeds"
    },
    {
      "Id": 300,
      "Name": "Amaranth",
      "SellPrice": 150,
      "Category": "Vegetable"
    },
    {
      "Id": 301,
      "Name": "Grape Starter",
      "SellPrice": 30,
      "Category": "Seeds"
    },
    {
      "Id": 302,
      "Name": "Hops Starter",
      "SellPrice": 30,
      "Category": "Seeds"
    },
    {
      "Id": 303,
      "Name": "Pale Ale",
      "SellPrice": 300,
      "Category": "ArtisanGood"
    },
    {
      "Id": 304,
      "Name": "Hops",
      "SellPrice": 25,
      "Category": "Vegetable"
    },
    {
      "Id": 346,
      "Name": "Beer",
      "SellPrice": 200,
      "Category": "ArtisanGood"
    },
    {
      "Id": 347,
      "Name": "Rare Seed",
      "SellPrice": 200,
      "Category": "Seeds"
    },
    {
      "Id": 376,
      "Name": "Poppy",
      "SellPrice": 140,
      "Category": "Flower"
    },
    {
      "Id": 395,
      "Name": "Coffee",
      "SellPrice": 150,
      "Category": "Other"
    },
    {
      "Id": 396,
      "Name": "Spice Berry",
      "SellPrice": 80,
      "Category": "Fruit"
    },
    {
      "Id": 398,
      "Name": "Grape",
      "SellPrice": 80,
      "Category": "Fruit"
    },
    {
      "Id": 400,
      "Name": "Strawberry",
      "SellPrice": 120,
      "Category": "Fruit"
    },
    {
      "Id": 402,
      "Name": "Sweet Pea",
      "SellPrice": 50,
      "Category": "Flower"
    },
    {
      "Id": 404,
      "Name": "Common Mushroom",
      "SellPrice": 40,
      "Category": "Forage"
    },
    {
      "Id": 406,
      "Name": "Wild Plum",
      "SellPrice": 80,
      "Category": "Fruit"
    },
    {
      "Id": 408,
      "Name": "Hazelnut",
      "SellPrice": 90,
      "Category": "Forage"
    },
    {
      "Id": 410,
      "Name": "Blackberry",
      "SellPrice": 20,
      "Category": "Fruit"
    },
    {
      "Id": 412,
      "Name": "Winter Root",
      "SellPrice": 70,
      "Category": "Forage"
    },
    {
      "Id": 414,
      "Name": "Crystal Fruit",
      "SellPrice": 150,
      "Category": "Fruit"
    },
    {
      "Id": 416,
      "Name": "Snow Yam",
      "SellPrice": 100,
      "Category": "Forage"
    },
    {
      "Id": 417,
      "Name": "Sweet Gem Berry",
      "SellPrice": 3000,
      "Category": "Other"
    },
    {
      "Id": 418,
      "Name": "Crocus",
      "SellPrice": 60,
      "Category": "Flower"
    },
    {
      "Id": 421,
      "Name": "Sunflower",
      "SellPrice": 80,
      "Category": "Flower"
    },
    {
      "Id": 423,
      "Name": "Rice",
      "SellPrice": 100,
      "Category": "Other"
    },
    {
      "Id": 425,
      "Name": "Fairy Seeds",
      "SellPrice": 100,
      "Category": "Seeds"
    },
    {
      "Id": 427,
      "Name": "Tulip Bulb",
      "SellPrice": 10,
      "Category": "Seeds"
    },
    {
      "Id": 429,
      "Name": "Jazz Seeds",
      "SellPrice": 15,
      "Category": "Seeds"
    },
    {
      "Id": 431,
      "Name": "Sunflower Seeds",
      "SellPrice": 20,
      "Category": "Seeds"
    },
    {
      "Id": 433,
      "Name": "Coffee Bean",
      "SellPrice": 15,
      "Category": "Seeds"
    },
    {
      "Id": 453,
      "Name": "Poppy Seeds",
      "SellPrice": 50,
      "Category": "Seeds"
    },
    {
      "Id": 454,
      "Name": "Ancient Fruit",
      "SellPrice": 550,
      "Category": "Fruit"
    },
    {
      "Id": 455,
      "Name": "Spangle Seeds",
      "SellPrice": 25,
      "Category": "Seeds"
    },
    {
      "Id": 472,
      "Name": "Parsnip Seeds",
      "SellPrice": 10,
      "Category": "Seeds"
    },
    {
      "Id": 473,
      "Name": "Bean Starter",
      "SellPrice": 30,
      "Category": "Seeds"
    },
    {
      "Id": 474,
      "Name": "Cauliflower Seeds",
      "SellPrice": 40,
      "Category": "Seeds"
    },
    {
      "Id": 475,
      "Name": "Potato Seeds",
      "SellPrice": 25,
      "Category": "Seeds"
    },
    {
      "Id": 476,
      "Name": "Garlic Seeds",
      "SellPrice": 20,
      "Category": "Seeds"
    },
    {
      "Id": 477,
      "Name": "Kale Seeds",
      "SellPrice": 35,
      "Category": "Seeds"
    },
    {
      "Id": 478,
      "Name": "Rhubarb Seeds",
      "SellPrice": 50,
      "Category": "Seeds"
    },
    {
      "Id": 479,
      "Name": "Melon Seeds",
      "SellPrice": 40,
      "Category": "Seeds"
    },
    {
      "Id": 480,
      "Name": "Tomato Seeds",
      "SellPrice": 25,
      "Category": "Seeds"
    },
    {
      "Id": 481,
      "Name": "Blueberry Seeds",
      "SellPrice": 40,
      "Category": "Seeds"
    },
    {
      "Id": 482,
      "Name": "Pepper Seeds",
      "SellPrice": 20,
      "Category": "Seeds"
    },
    {
      "Id": 483,
      "Name": "Wheat Seeds",
      "SellPrice": 5,
      "Category": "Seeds"
    },
    {
      "Id": 484,
      "Name": "Radish Seeds",
      "SellPrice": 20,
      "Category": "Seeds"
    },
    {
      "Id": 485,
      "Name": "Red Cabbage Seeds",
      "SellPrice": 50,
      "Category": "Seeds"
    },
    {
      "Id": 486,
      "Name": "Starfruit Seeds",
      "SellPrice": 200,
      "Category": "Seeds"
    },
    {
      "Id": 487,
      "Name": "Corn Seeds",
      "SellPrice": 75,
      "Category": "Seeds"
    },
    {
      "Id": 488,
      "Name": "Eggplant Seeds",
      "SellPrice": 10,
      "Category": "Seeds"
    },
    {
      "Id": 489,
      "Name": "Artichoke Seeds",
      "SellPrice": 15,
      "Category": "Seeds"
    },
    {
      "Id": 490,
      "Name": "Pumpkin Seeds",
      "SellPrice": 50,
      "Category": "Seeds"
    },
    {
      "Id": 491,
      "Name": "Bok Choy Seeds",
      "SellPrice": 25,
      "Category": "Seeds"
    },
    {
      "Id": 492,
      "Name": "Yam Seeds",
      "SellPrice": 30,
      "Category": "Seeds"
    },
    {
      "Id": 493,
      "Name": "Cranberry Seeds",
      "SellPrice": 60,
      "Category": "Seeds"
    },
    {
      "Id": 494,
      "Name": "Beet Seeds",
      "SellPrice": 10,
      "Category": "Seeds"
    },
    {
      "Id": 495,
      "Name": "Spring Seeds",
      "SellPrice": 35,
      "Category": "Seeds"
    },
    {
      "Id": 496,
      "Name": "Summer Seeds",
      "SellPrice": 55,
      "Category": "Seeds"
    },
    {
      "Id": 497,
      "Name": "Fall Seeds",
      "SellPrice": 45,
      "Category": "Seeds"
    },
    {
      "Id": 498,
      "Name": "Winter Seeds",
      "SellPrice": 30,
      "Category": "Seeds"
    },
    {
      "Id": 499,
      "Name": "Ancient Seeds",
      "SellPrice": 30,
      "Category": "Seeds"
    },
    {
      "Id": 591,
      "Name": "Tulip",
      "SellPrice": 30,
      "Category": "Flower"
    },
    {
      "Id": 593,
      "Name": "Summer Spangle",
      "SellPrice": 90,
      "Category": "Flower"
    },
    {
      "Id": 595,
      "Name": "Fairy Rose",
      "SellPrice": 290,
      "Category": "Flower"
    },
    {
      "Id": 597,
      "Name": "Blue Jazz",
      "SellPrice": 50,
      "Category": "Flower"
    },
    {
      "Id": 745,
      "Name": "Strawberry Seeds",
      "SellPrice": 0,
      "Category": "Seeds"
    },
    {
      "Id": 770,
      "Name": "Mixed Seeds",
      "SellPrice": 0,
      "Category": "Seeds"
    },
    {
      "Id": 771,
      "Name": "Fiber",
      "SellPrice": 1,
      "Category": "Other"
    },
    {
      "Id": 802,
      "Name": "Cactus Seeds",
      "SellPrice": 0,
      "Category": "Seeds"
    },
    {
      "Id": 830,
      "Name": "Taro Root",
      "SellPrice": 100,
      "Category": "Vegetable"
    },
    {
      "Id": 831,
      "Name": "Taro Tuber",
      "SellPrice": 20,
      "Category": "Seeds"
    },
    {
      "Id": 832,
      "Name": "Pineapple",
      "SellPrice": 300,
      "Category": "Fruit"
    },
    {
      "Id": 833,
      "Name": "Pineapple Seeds",
      "SellPrice": 240,
      "Category": "Seeds"
    },
    {
      "Id": 885,
      "Name": "Fiber Seeds",
      "SellPrice": 5,
      "Category": "Seeds"
    },
    {
      "Id": 4000,
      "Name": "Carrot Seeds",
      "SellPrice": 15,
      "Category": "Seeds"
    },
    {
      "Id": 4001,
      "Name": "Carrot",
      "SellPrice": 35,
      "Category": "Vegetable"
    },
    {
      "Id": 4002,
      "Name": "Summer Squash Seeds",
      "SellPrice": 20,
      "Category": "Seeds"
    },
    {
      "Id": 4003,
      "Name": "Summer Squash",
      "SellPrice": 45,
      "Category": "Vegetable"
    },
    {
      "Id": 4004,
      "Name": "Broccoli Seeds",
      "SellPrice": 40,
      "Category": "Seeds"
    },
    {
      "Id": 4005,
      "Name": "Broccoli",
      "SellPrice": 70,
      "Category": "Vegetable"
    },
    {
      "Id": 4006,
      "Name": "Powdermelon Seeds",
      "SellPrice": 20,
      "Category": "Seeds"
    },
    {
      "Id": 4007,
      "Name": "Powdermelon",
      "SellPrice": 60,
      "Category": "Fruit"
    }
  ],
  "Products": {
    "262": [
      {
        "Item": 346,
        "Processor": "Keg"
      },
      {
        "Item": 246,
        "Processor": "Mill"
      }
    ],
    "270": [
      {
        "Item": 247,
        "Processor": "Oil Maker"
      }
    ],
    "271": [
      {
        "Item": 423,
        "Processor": "Mill"
      }
    ],
    "284": [
      {
        "Item": 245,
        "Processor": "Mill",
        "Ratio": [
          1,
          3
        ]
      }
    ],
    "304": [
      {
        "Item": 303,
        "Processor": "Keg"
      }
    ],
    "421": [
      {
        "Item": 247,
        "Processor": "Oil Maker"
      }
    ],
    "431": [
      {
        "Item": 247,
        "Processor": "Oil Maker"
      }
    ],
    "433": [
      {
        "Item": 395,
        "Processor": "Keg",
        "Ratio": [
          5,
          1
        ]
      }
    ]
  },
  "FarmCrops": [
    {
      "Seed": 273,
      "Item": 271,
      "Amount": {
        "ExtraCropChance": 0.1,
        "CanDouble": false,
        "FarmLevelsPerYieldIncrease": 10
      },
      "Seasons": [
        "Spring"
      ],
      "Stages": [
        1,
        2,
        2,
        3
      ],
      "Paddy": true
    },
    {
      "Seed": 299,
      "Item": 300,
      "Amount": {
        "CanDouble": false
      },
      "Seasons": [
        "Fall"
      ],
      "Stages": [
        1,
        2,
        2,
        2
      ]
    },
    {
      "Seed": 301,
      "Item": 398,
      "Seasons": [
        "Fall"
      ],
      "Stages": [
        1,
        1,
        2,
        3,
        3
      ],
      "RegrowTime": 3
    },
    {
      "Seed": 302,
      "Item": 304,
      "Seasons": [
        "Summer"
      ],
      "Stages": [
        1,
        1,
        2,
        3,
        4
      ],
      "RegrowTime": 1
    },
    {
      "Seed": 347,
      "Item": 417,
      "Seasons": [
        "Fall"
      ],
      "Stages": [
        2,
        4,
        6,
        6,
        6
      ]
    },
    {
      "Seed": 425,
      "Item": 595,
      "Seasons": [
        "Fall"
      ],
      "Stages": [
        1,
        4,
        4,
        3
      ]
    },
    {
      "Seed": 427,
      "Item": 591,
      "Seasons": [
        "Spring"
      ],
      "Stages": [
        1,
        1,
        2,
        2
      ]
    },
    {
      "Seed": 429,
      "Item": 597,
      "Seasons": [
        "Spring"
      ],
      "Stages": [
        1,
        2,
        2,
        2
      ]
    },
    {
      "Seed": 431,
      "Item": 421,
      "Amount": {
        "CanDouble": false
      },
      "ExtraItem": [
        431,
        1.0
      ],
      "Seasons": [
        "Summer",
        "Fall"
      ],
      "Stages": [
        1,
        2,
        3,
        2
      ]
    },
    {
      "Seed": 433,
      "Item": 433,
      "Amount": {
        "MinCropYield": 4,
        "MaxCropYield": 4,
        "ExtraCropChance": 0.02
      },
      "Seasons": [
        "Spring",
        "Summer"
      ],
      "Stages": [
        1,
        2,
        2,
        3,
        2
      ],
      "RegrowTime": 2
    },
    {
      "Seed": 453,
      "Item": 376,
      "Seasons": [
        "Summer"
      ],
      "Stages": [
        1,
        2,
        2,
        2
      ]
    },
    {
      "Seed": 455,
      "Item": 593,
      "Seasons": [
        "Summer"
      ],
      "Stages": [
        1,
        2,
        3,
        2
      ]
    },
    {
      "Seed": 472,
      "Item": 24,
      "Seasons": [
        "Spring"
      ],
      "Stages": [
        1,
        1,
        1,
        1
      ]
    },
    {
      "Seed": 473,
      "Item": 188,
      "Seasons": [
        "Spring"
      ],
      "Stages": [
        1,
        1,
        1,
        3,
        4
      ],
      "RegrowTime": 3
    },
    {
      "Seed": 474,
      "Item": 190,
      "Giant": true,
      "Seasons": [
        "Spring"
      ],
      "Stages": [
        1,
        2,
        4,
        4,
        1
      ]
    },
    {
      "Seed": 475,
      "Item": 192,
      "Amount": {
        "ExtraCropChance": 0.2
      },
      "Seasons": [
        "Spring"
      ],
      "Stages": [
        1,
        1,
        1,
        2,
        1
      ]
    },
    {
      "Seed": 476,
      "Item": 248,
      "Seasons": [
        "Spring"
      ],
      "Stages": [
        1,
        1,
        1,
        1
      ]
    },
    {
      "Seed": 477,
      "Item": 250,
      "Amount": {
        "CanDouble": false
      },
      "Seasons": [
        "Spring"
      ],
      "Stages": [
        1,
        2,
        2,
        1
      ]
    },
    {
      "Seed": 478,
      "Item": 252,
      "Seasons": [
        "Spring"
      ],
      "Stages": [
        2,
        2,
        2,
        3,
        4
      ]
    },
    {
      "Seed": 479,
      "Item": 254,
      "Giant": true,
      "Seasons": [
        "Summer"
      ],
      "Stages": [
        1,
        2,
        3,
        3,
        3
      ]
    },
    {
      "Seed": 480,
      "Item": 256,
      "Amount": {
        "ExtraCropChance": 0.05
      },
      "Seasons": [
        "Summer"
      ],
      "Stages": [
        2,
        2,
        2,
        2,
        3
      ],
      "RegrowTime": 4
    },
    {
      "Seed": 481,
      "Item": 258,
      "Amount": {
        "MinCropYield": 3,
        "MaxCropYield": 3,
        "ExtraCropChance": 0.02
      },
      "Seasons": [
        "Summer"
      ],
      "Stages": [
        1,
        3,
        3,
        4,
        2
      ],
      "RegrowTime": 4
    },
    {
      "Seed": 482,
      "Item": 260,
      "Amount": {
        "ExtraCropChance": 0.03
      },
      "Seasons": [
        "Summer"
      ],
      "Stages": [
        1,
        1,
        1,
        1,
        1
      ],
      "RegrowTime": 3
    },
    {
      "Seed": 483,
      "Item": 262,
      "Amount": {
        "CanDouble": false
      },
      "ExtraItem": [
        178,
        0.4
      ],
      "Seasons": [
        "Summer",
        "Fall"
      ],
      "Stages": [
        1,
        1,
        1,
        1
      ]
    },
    {
      "Seed": 484,
      "Item": 264,
      "Seasons": [
        "Summer"
      ],
      "Stages": [
        2,
        1,
        2,
        1
      ]
    },
    {
      "Seed": 485,
      "Item": 266,
      "Seasons": [
        "Summer"
      ],
      "Stages": [
        2,
        1,
        2,
        2,
        2
      ]
    },
    {
      "Seed": 486,
      "Item": 268,
      "Seasons": [
        "Summer"
      ],
      "Stages": [
        2,
        3,
        2,
        3,
        3
      ]
    },
    {
      "Seed": 487,
      "Item": 270,
      "Seasons": [
        "Summer",
        "Fall"
      ],
      "Stages": [
        2,
        3,
        3,
        3,
        3
      ],
      "RegrowTime": 4
    },
    {
      "Seed": 488,
      "Item": 272,
      "Amount": {
        "ExtraCropChance": 0.002
      },
      "Seasons": [
        "Fall"
      ],
      "Stages": [
        1,
        1,
        1,
        1,
        1
      ],
      "RegrowTime": 5
    },
    {
      "Seed": 489,
      "Item": 274,
      "Seasons": [
        "Fall"
      ],
      "Stages": [
        2,
        2,
        1,
        2,
        1
      ]
    },
    {
      "Seed": 490,
      "Item": 276,
      "Giant": true,
      "Seasons": [
        "Fall"
      ],
      "Stages": [
        1,
        2,
        3,
        4,
        3
      ]
    },
    {
      "Seed": 491,
      "Item": 278,
      "Seasons": [
        "Fall"
      ],
      "Stages": [
        1,
        1,
        1,
        1
      ]
    },
    {
      "Seed": 492,
      "Item": 280,
      "Seasons": [
        "Fall"
      ],
      "Stages": [
        1,
        3,
        3,
        3
      ]
    },
    {
      "Seed": 493,
      "Item": 282,
      "Amount": {
        "MinCropYield": 2,
        "MaxCropYield": 2,
        "ExtraCropChance": 0.1
      },
      "Seasons": [
        "Fall"
      ],
      "Stages": [
        1,
        2,
        1,
        1,
        2
      ],
      "RegrowTime": 5
    },
    {
      "Seed": 494,
      "Item": 284,
      "Seasons": [
        "Fall"
      ],
      "Stages": [
        1,
        1,
        2,
        2
      ]
    },
    {
      "Seed": 499,
      "Item": 454,
      "Seasons": [
        "Spring",
        "Summer",
        "Fall"
      ],
      "Stages": [
        2,
        7,
        7,
        7,
        5
      ],
      "RegrowTime": 7
    },
    {
      "Seed": 745,
      "Item": 400,
      "Amount": {
        "ExtraCropChance": 0.02
      },
      "Seasons": [
        "Spring"
      ],
      "Stages": [
        1,
        1,
        2,
        2,
        2
      ],
      "RegrowTime": 4
    },
    {
      "Seed": 802,
      "Item": 90,
      "Seasons": [],
      "Stages": [
        2,
        2,
        2,
        3,
        3
      ],
      "RegrowTime": 3
    },
    {
      "Seed": 831,
      "Item": 830,
      "Seasons": [
        "Summer"
      ],
      "Stages": [
        1,
        2,
        3,
        4
      ],
      "Paddy": true
    },
    {
      "Seed": 833,
      "Item": 832,
      "Seasons": [
        "Summer"
      ],
      "Stages": [
        1,
        3,
        3,
        4,
        3
      ],
      "RegrowTime": 7
    },
    {
      "Seed": 885,
      "Item": 771,
      "Amount": {
        "MinCropYield": 4,
        "MaxCropYield": 7,
        "ExtraCropChance": 0.01,
        "CanDouble": false,
        "FarmingQualities": false
      },
      "ExtraItem": [
        770,
        0.1
      ],
      "Seasons": [
        "Spring",
        "Summer",
        "Fall",
        "Winter"
      ],
      "Stages": [
        1,
        2,
        2,
        2
      ]
    },
    {
      "Seed": 4000,
      "Item": 4001,
      "Seasons": [
        "Spring"
      ],
      "Stages": [
        1,
        1,
        1
      ]
    },
    {
      "Seed": 4002,
      "Item": 4003,
      "Seasons": [
        "Summer"
      ],
      "Stages": [
        1,
        1,
        1,
        1,
        2
      ],
      "RegrowTime": 3
    },
    {
      "Seed": 4004,
      "Item": 4005,
      "Seasons": [
        "Fall"
      ],
      "Stages": [
        1,
        2,
        2,
        3
      ],
      "RegrowTime": 4
    },
    {
      "Seed": 4006,
      "Item": 4007,
      "Giant": true,
      "Seasons": [
        "Winter"
      ],
      "Stages": [
        1,
        1,
        1,
        2,
        2
      ]
    }
  ],
  "ForageCrops": [
    {
      "Seed": 495,
      "Foragables": [
        16,
        18,
        20,
        22
      ],
      "SeedRecipeUnlockLevel": 1,
      "Season": "Spring",
      "Stages": [
        3,
        4
      ]
    },
    {
      "Seed": 496,
      "Foragables": [
        396,
        398,
        402
      ],
      "SeedRecipeUnlockLevel": 4,
      "Season": "Summer",
      "Stages": [
        3,
        4
      ]
    },
    {
      "Seed": 497,
      "Foragables": [
        404,
        406,
        408,
        410
      ],
      "SeedRecipeUnlockLevel": 6,
      "Season": "Fall",
      "Stages": [
        3,
        4
      ]
    },
    {
      "Seed": 498,
      "Foragables": [
        412,
        414,
        416,
        418
      ],
      "SeedRecipeUnlockLevel": 7,
      "Season": "Winter",
      "Stages": [
        3,
        4
      ]
    }
  ]
}